import { Wording } from '@surveycake/wording/survey';
import { getWording } from 'app/core/http';
import { Exception } from 'app/core/status';
import { defaultLanguage, languageWhitelist } from 'config/system';

/**
 * To recursively get the wording.
 * Will return the wording data until anyone successfully fetched, or throw exception.
 */
async function get(
  lang?: string,
  ...others: Array<string | undefined>
): Promise<Wording> {
  if (!lang && others.length === 0) {
    throw new Exception('NOT_FOUND');
  }

  try {
    if (lang && languageWhitelist.includes(lang)) {
      return await getWording(lang);
    }

    return await get(...others);
  } catch (error) {
    return await get(...others);
  }
}

/**
 * To get the wording from languages.
 */
export async function initialWording(...languages: Array<string | undefined>) {
  try {
    /**
     * If the wording are not found, it will get the wording from defaultLanguage.
     */
    return await get(...languages, defaultLanguage);
  } catch (error) {
    throw error;
  }
}
